import { render, staticRenderFns } from "./TireScroll.vue?vue&type=template&id=79d1bb9a&scoped=true&"
var script = {}
import style0 from "./TireScroll.vue?vue&type=style&index=0&id=79d1bb9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d1bb9a",
  null
  
)

export default component.exports